import { tw } from '@/utils/tw';

const ScrollArticleLabel = tw.theme({
  base: `my-4 flex flex-row items-center gap-3 whitespace-nowrap text-headline-xs before:h-0.25 before:w-full before:bg-black after:h-0.25 after:w-full after:bg-black`,
});

export default ScrollArticleLabel;
